import { Injectable, Inject, Output, EventEmitter, Directive, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserModel, LanguageModel } from '@models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

import { AuthServices } from './auth.services';
import { UserServices } from './user.services';
import { ClockService } from './clockTimer.services';
import { DictionaryServices } from './dictionary.services';
import { AlertServices } from './alert.services';

import { environment as env } from 'environments/environment';
import { ConfigService, ITemplateConfig } from '../../app/shared/services/config.service';


@Injectable()
export class AppServices {
  @Output() onSessionToBeLocked: EventEmitter<any> = new EventEmitter();
  @Output() onSessionToBeLogOut: EventEmitter<any> = new EventEmitter();
  @Output() onLockSession: EventEmitter<any> = new EventEmitter();
  @Output() onLogoutSession: EventEmitter<any> = new EventEmitter();
  @Output() onOpenCustomizer: EventEmitter<any> = new EventEmitter();

  private TimeOutHandler = null;
  private TimeOutNotify = null;

  constructor(
    @Inject('AuthServices') private _authServices: AuthServices,
    @Inject('UserServices') private _userServices: UserServices,
    @Inject('ClockService') private clockService: ClockService,
    @Inject('DictionaryServices') private _dictionaryServices: DictionaryServices,
    @Inject('AlertServices') private _alertServices: AlertServices,
    private configService: ConfigService,
    public translate: TranslateService,
    private http: HttpClient,
    private router: Router,
  ) { }

  //APPLICATION SETTINGS FOR EACH USER

  // Get Current Profile. If not exist the Create the default profile
  getAppSettings(): ITemplateConfig {
    const _value = localStorage.getItem('AppSettings');
    return _value ? JSON.parse(_value) : this.setDefaultAppSettings();
  };


  // SET and GET Current App User Settings
  setAppSettings(_appSettings: ITemplateConfig): void {
    localStorage.setItem('AppSettings', JSON.stringify(_appSettings))
    this.configService.templateConf = _appSettings
  };

  setDefaultAppSettings(): any {
    let _AppSettings: ITemplateConfig = this.configService.templateConf
    localStorage.setItem('AppSettings', JSON.stringify(_AppSettings))
    return _AppSettings
  };

  //Get the Current User Active Language
  getCurrentActiveLanguage(): any {
    let _AppSettings: ITemplateConfig;
    _AppSettings = JSON.parse(localStorage.getItem('AppSettings'))
    let ActiveUserLang = _AppSettings ? _AppSettings.layout.appsettings.language : 'en';
    return ActiveUserLang
  }

  // APP PROFILE LANGUAGE - USE APPSETTINGS
  applyAppSettings() {

    let _AppSettings: ITemplateConfig;
    _AppSettings = JSON.parse(localStorage.getItem('AppSettings'))
    let browserLang = _AppSettings ? _AppSettings.layout.appsettings.language : 'en';

    let _LoggedInUser = this._userServices.getLoggedInUser()
    if (_LoggedInUser) {
      browserLang = browserLang + '_' + _LoggedInUser.InstanceID
    }

    //TRY TO LOAD TRANSLATION 
    this.translate.use(browserLang).subscribe((_Response) => {
      // console.log(_Response)  //Show the translation json file
    }, (_error) => {
      //console.log(_error)
      //WHEN API SERVER NOT RESPONDING
      //TODO IMPLEMENT THIS TO ALL REQUESTs
      if (_error.status === 0) { this.router.navigate(['maintenance']) }
    });

    //this.translate.use(browserLang2.match(/en|es|pt|de|gr|tran/) ? browserLang2 : 'en');

    // const browserLang = localStorage.getItem('language') ? localStorage.getItem('language') : "en";
    // // const browserLang: string = this.translate.getBrowserLang();
    // this.translate.use(browserLang.match(/en|es|pt|de|gr/) ? browserLang : 'en');
    // return  _browserLang  ? _browserLang : this.translate.getBrowserLang();
    // const browserLang: string = localStorage.getItem('language') ? "" : this.translate.getBrowserLang(); ;


   
  }

  changeApplicationLanguage(language: string) {

    let _AppSettings: ITemplateConfig;
    _AppSettings = this.getAppSettings();

    //_AppSettings = JSON.parse(localStorage.getItem('AppSettings'))
    // Avoid Save Changes if Click on the same language
    if (_AppSettings.layout.appsettings.language !== language) {
      _AppSettings.layout.appsettings.language = language
      this._saveAppSetting(_AppSettings)
    }

  }

  _saveAppSetting(_AppSettings: ITemplateConfig) {

    this._userServices.saveUserSettings(_AppSettings).subscribe((_Response) => {
      // this.translate.use(_AppSettings.Language);
      this.setAppSettings(_AppSettings);
      this.applyAppSettings();

    }, (_error) => {

      const _ErrorResponse = JSON.parse(_error._body);
      this._alertServices.ShowMessage('error', 'app.trn-error-title', _ErrorResponse.ErrorMessage);
      // ('Error saving App Settings ( language )')
    });

  }


  // APP APPLICATION LANGUAGES [ ENGLISH / GREEK / ...... ]
  getAppLanguages(): Observable<LanguageModel> {
    return Observable.create((_operator) => {
      this._dictionaryServices.GetApplicationLanguages().subscribe((_applicationlanguages: LanguageModel) => {
        _operator.next(_applicationlanguages)
      }, (_error) => { _operator.error(_error); }
      );
    });
  }

  //TODO CURRENTLY NOT USED BY APP TO SELECT COLOR
  getAppColors(): Observable<any> {
    return this.http.get('./assets/data.json')
  }

  // TODO : Get the Settings for the logged in User
  //       If null then use default
  //       If User change settings then save them to Database
  // MOVE THIS TO APP.SERVICES OR NEW SETTINGS.SERVICES
  _getAppSetting() {
    return Observable.create((_operator) => {

      this._authServices.GetAuthenticatedUser().subscribe((_users: UserModel) => {
        // GET USER AppSettings If not Null then Use Default
        // Otherwise Replace with User Settings ( Try Catch to Avoid Crashes)
        if (_users[0].AppSettings) {
          try {
            let _AppSettings: ITemplateConfig;
            _AppSettings = JSON.parse(_users[0].AppSettings)
            this.setAppSettings(_AppSettings);
          } catch {

            this._alertServices.ShowMessage('error', 'app.trn-error-title', 'app.trn-error-user-settings');

          }
        }

        _operator.next(_users[0])
      }, (_error) => { _operator.error(_error); }

      );

    });
  }


  getTranslation(value): any {

    this.translate.get(value).subscribe((res: string) => {
      return res
    });

  };

  //Retun if is Mobile ( true or false)
  isMobileAppAgent() {
    return new Observable((_operator) => {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        // true for mobile device
        _operator.next(true);
      } else {
        _operator.next(false);
        // false for not mobile device
      }

    })
  }



  public Logout() {

    this.onLogoutSession.emit(); // Added for Modal

    clearTimeout(this.TimeOutNotify); // Stop Notify Timer
    clearTimeout(this.TimeOutHandler); // Stop Expiration Timer

    this.ClearLocalStorage();

    //We need to reload page in order to clear the active router config ( modules etc...)
    //Actually to reload app.component
    //this.router.navigate(['/login',{}]);  //DO NOT USE THIS IF MULTI PROJECT ACCESS 


    //both work on client Testing on mobile
    //window.location.href = './login';
    window.location.href = './index.html';  //works on mobile 

  }

  public ClearLocalStorage() {
    // SAVED IN LOCALSTORAGE
    // ========================
    // AuthToken  ( string )
    // AuthSalt   ( string )
    // _date      ( string )
    // LoggedInUser ( object )
    // AppSettings ( Object )

    // Clear All Above From LocalStorage
    localStorage.clear();

    // Clear Only what is neccessary..
    // Keep AppSettings mainly for language and based on User login then Replace from Database
    localStorage.removeItem('AuthToken');
    localStorage.removeItem('AuthSalt');
    localStorage.removeItem('LoggedInUser');
    localStorage.removeItem('_date');

  }

  public LockSystem() {

    // Lock system if isAuthorized ( AuthToken and AuthSalt Exist)
    if (this._authServices.isAuthorized()) {
      localStorage.removeItem('_date');
      localStorage.removeItem('AuthSalt');
      this.onLockSession.emit();
      // this._router.navigate(['lock']);
    }
  }

  // TODO :
  // 1. MOVE ALL NOT RELATED TO APP SECTION
  // 2. Notify User x minutes for lock and logout Done Not Tested

  public RefreshSession() {
    // ("Refresh Session")
    // Auto Set Timeout for Lock or Logout Session
    // if authenticated then Logout
    // If authorized then lock and then logout
    clearTimeout(this.TimeOutHandler)
    clearTimeout(this.TimeOutNotify)

    if (this._authServices.isAuthenticated() && !this._authServices.isAuthorized()) {
      // ("going for logout")
      // Notify User that Session is going to be logout
      this.TimeOutNotify = setTimeout(() => { this.onSessionToBeLogOut.emit(this.clockService.Convert_milliseconds_To_Hours(env.NotificationTime)) }, env.loginTimeout - env.NotificationTime);
      // Time Expired - Logout User
      this.TimeOutHandler = setTimeout(() => { this.SessionLogoutTimeOut() }, env.loginTimeout - env.lockTimeout);
    }

    if (this._authServices.isAuthorized()) {
      // ("going for lock the system")
      // Notify User that Session is going to be locked ??? Minutes before locked out
      this.TimeOutNotify = setTimeout(() => { this.onSessionToBeLocked.emit(this.clockService.Convert_milliseconds_To_Hours(env.NotificationTime)) }, env.lockTimeout - env.NotificationTime);
      // Time Expired - lock User
      this.TimeOutHandler = setTimeout(() => { this.SessionLockedTimeOut() }, env.lockTimeout);
    }

    const _date = localStorage.getItem('_date');
    if (_date) {
      const _lastTime = Number(_date);
      const _now = new Date().getTime();
      const _idleTime = Math.abs(_now - _lastTime);

      if (_idleTime > env.lockTimeout) {

        if (_idleTime > env.loginTimeout) {
          this.Logout();
        } else {
          this.LockSystem();
        }
      } else {
        localStorage.removeItem('_date');
      }
    }
    localStorage.setItem('_date', Date.now().toString());


  }

  public SessionLockedTimeOut() {
    // Notify User that Session is going to be logout
    this.TimeOutNotify = setTimeout(() => { this.onSessionToBeLogOut.emit(this.clockService.Convert_milliseconds_To_Hours(env.NotificationTime)) }, env.loginTimeout - env.lockTimeout - env.NotificationTime);
    this.TimeOutHandler = setTimeout(() => { this.SessionLogoutTimeOut() }, env.loginTimeout - env.lockTimeout);
    this.LockSystem();
  }

  public SessionLogoutTimeOut() {
    this.Logout();
  }


  public OpenCustomizer() {
    this.onOpenCustomizer.emit()
  }


  GetGreekLowerCaseTranslation(val?): any {

    //let transliteration = { "a": "α", "b": "β", "d": "δ", "e": "ε", "ai": "αι", "av": "αυ", "v": "β", "g": "γ", "ks": "ξ", "m": "μ" };
    // let GrVal = val.toLowerCase().replace(/a|b|d|e|ai|av|ng|v|g|ks|m|.../g, chr => transliteration[chr]);

    let transliteration =
    {
      " ": " ",
      "a": "α",
      "b": "β",
      "c": "κ",
      "d": "δ",
      "e": "ε",
      "f": "φ",
      "g": "γ",
      "h": "η",
      "i": "ι",
      "j": "τζ",
      "k": "κ",
      "l": "λ",
      "m": "μ",
      "n": "ν",
      "o": "ο",
      "p": "π",
      "q": "θ",
      "r": "ρ",
      "s": "σ",
      "t": "τ",
      "u": "υ",
      "v": "β",
      "w": "ω",
      "x": "χ",
      "y": "υ",
      "z": "ζ",
      "th": "θ",
      "ks": "ξ",
      "ph": "φ",
      "ch": "χ",
      "ai": "αι",
      "av": "αυ",
      "fx": "ξ",
      "af": "αυ",
      "ng": "γγ",
      "gk": "γκ",
      "nx": "γξ",
      "nch": "γχ",
      "ev": "ευ",
      "oy": "ου",
      "ps": "ψ",
      "afx": "αυξ",
    }

    let GrVal: string = ""
    const SplitWords = val.split(" ");
    if (SplitWords.length > 0) {

      SplitWords.forEach(word => {

        let TransVal = word.toLowerCase().trim().replace(/afx|ps|fx|th|ks|ph|ch|ai|av|af|ng|gk|nx|nch|ev|oy|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|.../g, chr => transliteration[chr]);
        if (!GrVal) { GrVal = TransVal } else { GrVal = GrVal + " " + TransVal }

      });

    } else {
      GrVal = val.toLowerCase().trim().replace(/afx|ps|fx|th|ks|ph|ch|ai|av|af|ng|gk|nx|nch|ev|oy|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|.../g, chr => transliteration[chr]);
    }

    return GrVal;

  }

  GetGreekUpperCaseTranslation(val?): any {

    //let transliteration = { "a": "α", "b": "β", "d": "δ", "e": "ε", "ai": "αι", "av": "αυ", "v": "β", "g": "γ", "ks": "ξ", "m": "μ" };
    // let GrVal = val.toLowerCase().replace(/a|b|d|e|ai|av|ng|v|g|ks|m|.../g, chr => transliteration[chr]);

    let transliteration =
    {
      " ": " ",
      "A": "Α",
      "B": "Β",
      "C": "Κ",
      "D": "Δ",
      "E": "Ε",
      "F": "Φ",
      "G": "Γ",
      "H": "Η",
      "I": "Ι",
      "J": "ΤΖ",
      "K": "Κ",
      "L": "Λ",
      "M": "Μ",
      "N": "Ν",
      "O": "Ο",
      "P": "Π",
      "Q": "Θ",
      "R": "Ρ",
      "S": "Σ",
      "T": "Τ",
      "U": "Υ",
      "V": "Β",
      "W": "Ω",
      "X": "Χ",
      "Y": "Υ",
      "Z": "Ζ",
      "TH": "Θ",
      "KS": "Ξ",
      "PH": "Φ",
      "CH": "Χ",
      "AI": "ΑΙ",
      "AV": "ΑΥ",
      "FX": "Ξ",
      "AF": "ΑΥ",
      "NG": "ΓΓ",
      "GK": "ΓΚ",
      "NX": "ΓΞ",
      "NCH": "ΓΧ",
      "EV": "ΕΥ",
      "OY": "ΟΥ",
      "PS": "Ψ",
      "AFX": "ΑΥΞ",
    }

    let GrVal: string = ""
    const SplitWords = val.split(" ");
    if (SplitWords.length > 0) {

      SplitWords.forEach(word => {

        let TransVal = word.toUpperCase().trim().replace(/AFX|PS|FX|TH|KS|PH|CH|AI|AV|AF|NG|GK|NX|NCH|EV|OY|A|B|C|D|E|F|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|.../g, chr => transliteration[chr]);
        if (TransVal === 'undefined') { GrVal = '' }
        if (!GrVal) { GrVal = TransVal } else { GrVal = GrVal + " " + TransVal }

      });

    } else {
      GrVal = val.toUpperCase().trim().replace(/AFX|PS|FX|TH|KS|PH|CH|AI|AV|AF|NG|GK|NX|NCH|EV|OY|A|B|C|D|E|F|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|.../g, chr => transliteration[chr]);
    }

    return GrVal;
  }

}



